<template>
  <div class="mt-4" style="overflow: auto">
    <div @click="navigateToFlightOperationsView()" style="cursor: pointer;">
      <b-icon icon="chevron-left"></b-icon>&nbsp;Zurück
    </div>

    <h2 class="mt-4">Dienstbuch - Archiv</h2>
    <b-alert variant="info" show class="text-center">
      <div>
        <b-icon icon="info-circle" font-scale="1.5"></b-icon>
        <br />
        Um eine Datei herunterzuladen, muss ein
        <strong>markierter Tag</strong> ausgewählt werden.
      </div>
    </b-alert>
    <b-overlay :show="loading">
      <v-calendar :attributes="attributes" @dayclick="exportPdf" is-expanded />
    </b-overlay>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "serviceBookArchiveView",
  components: {},
  data() {
    return {
      entries: [],

      loading: true,

      attributes: [],

      apiUrl: process.env.VUE_APP_API_URL,
    };
  },

  computed: {},

  methods: {
    navigateToFlightOperationsView() {
      this.$router.push(`/flight-operations`);
    },

    changeDate(date) {
      this.date = date;
    },

    async exportPdf(date) {
      this.loading = true;
      try {
        const response = await axios.post(
          this.apiUrl + "/service-book/export-pdf",
          {
            date: date.id,
          },
          {
            responseType: "blob",
          }
        );

        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", date.id + "_Dienstbucheintrag.pdf");
        document.body.appendChild(link);
        link.click();
        link.remove();
        this.loading = false;
      } catch (error) {
        console.error("Fehler beim Exportieren des PDFs:", error);
        this.loading = false;
      }
    },
  },

  beforeMount() {
    this.loading = true;
    axios
      .get(this.apiUrl + "/service-book/get-entries")
      .then((response) => {
        this.entries = response.data.entries;

        this.attributes = [
          {
            highlight: true,
            dates: Object.values(this.entries).map(
              (item) => new Date(item.date)
            ),
          },
        ];

        this.loading = false;
      })
      .catch((error) => {
        console.error("Error fetching data:", error);

        if (error.status === 401) {
          localStorage.removeItem("token");
        }
      });
  },
};
</script>

<style scoped></style>
